import React from 'react';
import { Redirect } from 'react-router-dom'

const Admin = () => (
    <Redirect to='/orgs' />
);

export default Admin;